import React, { useState } from "react";
import { Link } from "react-router-dom";
import HamburgerMenu from "./HamburgerMenu";

export default function FAQs() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((open) => !open);

  const faqs = [
    {
      question: "How does WhatGradeWillItGet.com work?",
      answer:
        "You upload clear photos of your card (front, back, corners). Our expert graders analyze the images and return a realistic grade estimate and value analysis.",
    },
    {
      question: "What types of cards can I submit?",
      answer:
        "We accept all major sports and trading card games including baseball, basketball, Pokémon, Yu-Gi-Oh!, One Piece, and more.",
    },
    {
      question: "How long does grading take?",
      answer:
        "Most submissions will be returned in 1–2 hours, but it could take up to 12 hours during high volume times. You’ll be notified by email once your grading report is ready.",
    },
    {
      question: "Is this an official grading company?",
      answer:
        "No, we do not assign official grades for encapsulation. We provide realistic pre-submission evaluations to help you choose the best grading service.",
    },
    {
      question: "Do I need to mail in my card?",
      answer:
        "Nope — all grading is done using photos. Just upload clear, high-resolution images to get started.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-black text-white font-[Montserrat] flex flex-col">
      {/* Header with only hamburger menu */}
      <nav className="flex justify-end items-center px-6 py-4 relative z-20">
        <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
      </nav>

      {/* Content */}
      <div className="px-5 pt-6 pb-20 w-full max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-left mb-4">Frequently Asked Questions</h1>
        {faqs.map((faq, index) => (
          <div key={index} className="border border-gray-700 rounded-lg">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full text-left px-6 py-4 font-semibold focus:outline-none"
            >
              {faq.question}
            </button>
            {activeIndex === index && (
              <div className="px-6 pb-4 text-gray-300 text-left">{faq.answer}</div>
            )}
          </div>
        ))}

        <div className="mt-6 px-6 text-left font-bold text-white">
          Have a question not listed on this page?{" "}
          Contact us{" "}
          <Link to="/contact" className="text-blue-400 underline">
            here
          </Link>
          .
        </div>
      </div>
    </div>
  );
}
